module.exports = __webpack_public_path__ + "img/45.cd30fb7.jpg";